<div class="m-content">
	<div class="row">
		<div class="col-xl-3 col-lg-4">
			<div class="m-portlet m-portlet--full-height">
				<div class="m-portlet__body">
					<div class="m-card-profile">
						<div class="m-card-profile__title m--hide"> Kullanıcı Bilgisi </div>
						<div class="m-card-profile__pic">
							<div class="m-card-profile__pic-wrapper">
								<img src="./assets/app/media/img/users/user1.jpg"
									alt="{{userModel.Name}} {{userModel.LastName}}"
									*ngIf="userModel.Logo === undefined || userModel.Logo === null" />
								<img src="{{userModel.Logo}}" alt="{{userModel.Name}} {{userModel.LastName}}"
									*ngIf="userModel.Logo !== undefined && userModel.Logo !== null" />
							</div>
						</div>
						<div class="m-card-profile__details">
							<span class="m-card-profile__name"> {{userModel.Name}} {{userModel.LastName}} </span>
							<a href="" class="m-card-profile__email m-link"> {{userModel.Email}} </a>
						</div>
						<br />
						<div class="m-portlet__body-separator"></div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-xl-9 col-lg-8">
			<div class="m-portlet m-portlet--full-height m-portlet--tabs">
				<div class="m-portlet__head">
					<div class="m-portlet__head-tools">
						<ul class="nav nav-tabs m-tabs m-tabs-line   m-tabs-line--left m-tabs-line--primary"
							role="tablist">
							<li class="nav-item m-tabs__item">
								<a class="nav-link m-tabs__link active" data-toggle="tab" href="#m_user_profile_tab_1"
									role="tab">
									<i class="flaticon-share m--hide"></i> Bilgilerim </a>
							</li>
							<li class="nav-item m-tabs__item">
								<a class="nav-link m-tabs__link" data-toggle="tab" href="#m_user_profile_tab_3"
									role="tab"> Şifre Değiştir </a>
							</li>
							<li class="nav-item m-tabs__item">
								<a class="nav-link m-tabs__link" data-toggle="tab" href="#m_user_profile_tab_4"
									role="tab"> Resim Yükle </a>
							</li>
							<!-- <li class="nav-item m-tabs__item">
								<a class="nav-link m-tabs__link" data-toggle="tab" href="#m_user_profile_tab_2"
									role="tab"> İşlem Geçmişi </a>
							</li> -->
						</ul>
					</div>
					<div class="m-portlet__head-tools">
						<ul class="m-portlet__nav">
							<li class="m-portlet__nav-item m-portlet__nav-item--last">
							</li>
						</ul>
					</div>
				</div>
				<div class="tab-content">
					<div class="tab-pane active" id="m_user_profile_tab_1">
						<br />
						<form class="m-form m-form--fit m-form--label-align-right">
							<div class="m-portlet__body">
								<br />
								<div class="form-group m-form__group m--margin-top-10 m--hide">
									<div class="alert m-alert m-alert--default show" role="alert">
									</div>
								</div>
								<div class="form-group m-form__group row">
									<div class="col-10 ml-auto">
										<h3 class="m-form__section">
										</h3>
									</div>
								</div>
								<div class="form-group m-form__group row" hidden="hidden">
									<label for="example-text-input" class="col-2 col-form-label"> Kullanıcı Adı </label>
									<div class="col-7">
										<input class="form-control m-input" maxlength="150" type="text" id="UserName"
											name="UserName" [(ngModel)]="userModel.UserName" />
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label for="example-text-input" class="col-2 col-form-label" > E-Mail </label>
									<div class="col-7">
										<input class="form-control m_input" maxlength="255" type="text" id="Email"
											name="Email" [(ngModel)]="userModel.Email" />
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label for="example-text-input" class="col-2 col-form-label"> Adı </label>
									<div class="col-7">
										<input class="form-control m_input" type="text" id="Name" name="Name"
											[(ngModel)]="userModel.Name" />
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label for="example-text-input" class="col-2 col-form-label"> Soyadı </label>
									<div class="col-7">
										<input class="form-control m_input" maxlength="150" type="text" id="LastName"
											name="LastName" [(ngModel)]="userModel.LastName" />
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label for="example-text-input" class="col-2 col-form-label"> Telefon No </label>
									<div class="col-7">
										<input class="form-control m_input" maxlength="50" type="text" id="PhoneNumber"
											name="PhoneNumber" [(ngModel)]="userModel.PhoneNumber" prefix="+90"
											mask="000 000 00 00" [showMaskTyped]="true" maxlength="60" />
									</div>
								</div>
								<br />
							</div>
							<div class="m-portlet__foot m-portlet__foot--fit">
								<div class="m-form__actions">
									<div class="row">
										<div class="col-2"></div>
										<div class="col-7 m_btn">
											<button type="button" class="btn btn-accent m-btn m-btn--air m-btn--custom"
												(click)="SaveUser();"> Güncelle </button> &nbsp;&nbsp;
											<!-- <button type="button" class="btn btn-secondary m-btn m-btn--air m-btn--custom" (click)="GetUser();">
												İptal
											</button> -->
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
					<!-- <div class="tab-pane" id="m_user_profile_tab_2">
						<div class="m_datatable m-datatable m-datatable--default m-datatable--loaded" id="local_data"  [style.height.px]="portletBodyHeight">

							<ag-grid-angular style="width: 100%;height: 100%;" class="ag-theme-balham"
								[modules]='modules' [gridOptions]='gridOptions' [columnDefs]='columnDefs'
								[rowData]='rowData' (gridReady)="onGridReady($event)">
							</ag-grid-angular>
						</div>
					</div> -->
					<div class="tab-pane" id="m_user_profile_tab_3">
						<br />
						<form class="m-form m-form--fit m-form--label-align-right">
							<div class="m-portlet__body">
								<br />
								<div class="form-group m-form__group m--margin-top-10 m--hide">
									<div class="alert m-alert m-alert--default show" role="alert">
									</div>
								</div>
								<div class="form-group m-form__group row">
									<div class="col-10 ml-auto">
										<h3 class="m-form__section">
										</h3>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label for="example-text-input" class="col-2 col-form-label"> Şifre </label>
									<div class="col-7">
										<input class="form-control m_input" type="password" id="userOldPassword"
											name="userOldPassword" (keyup)="PasswordChange();"
											[(ngModel)]="userOldPassword" autocomplete="on" />
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label for="example-text-input" class="col-2 col-form-label"> Yeni Şifre </label>
									<div class="col-7">
										<input class="form-control m_input" type="password"
											[disabled]="passwordChangeStatus" id="PasswordHashNew"
											name="PasswordHashNew" [(ngModel)]="userModel.PasswordHashNew"
											(change)="changesData();" autocomplete="on" />
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label for="example-text-input" class="col-2 col-form-label"> Yeni Şifre Tekrar
									</label>
									<div class="col-7">
										<input class="form-control m_input" type="password"
											[disabled]="passwordChangeStatus" id="PasswordHashNewAgain"
											name="PasswordHashNewAgain" [(ngModel)]="userModel.PasswordHashNewAgain"
											(change)="changesData();" autocomplete="on" />
									</div>
								</div>
								<br />
							</div>
							<div class="m-portlet__foot m-portlet__foot--fit">
								<div class="m-form__actions">
									<div class="row">
										<div class="col-2"></div>
										<div class="col-7 m_btn">
											<button type="button" class="btn btn-accent m-btn m-btn--air m-btn--custom"
												(click)="SavePaswordChange();"> Güncelle </button> &nbsp;&nbsp; <button
												type="button" class="btn btn-secondary m-btn m-btn--air m-btn--custom"
												(click)="PasswordClear();"> İptal </button>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
					<div class="tab-pane" id="m_user_profile_tab_4">
						<br /><br />
						<div class="m-portlet__body" style="width: 90%; height: 300px;">
							<div style="text-align:center">
								<label>
									<div>
										<label for="files" [hidden]="selectedFiles" class="btn btn-primary"
											style="width: 157px;">Resim Seç (PNG, JPG)</label>
										<input id="files" #filesupload style="visibility:hidden;width:0px;" type="file"
											accept=".jpg, .jpeg, .png" (change)="selectFile($event);">
									</div>
									<div>
										<button [hidden]="!selectedFiles" class="btn btn-success" style="width: 157px;"
											(click)="upload();">Resmi Yükle</button>
										<button [hidden]="!selectedFiles" class="btn btn-danger" style="width: 157px;"
											(click)="uploadCancel();">iptal</button>
									</div>
								</label>
							</div>
						</div>
						<br /><br />
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<!--begin::Modal MessageComponent-->
<MessageVBT #messageVbt></MessageVBT>
<!--end::Modal MessageComponent-->
